/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'quote': {
    width: 16,
    height: 16,
    viewBox: '0 0 68 45',
    data: '<g _fill="#FFF" fill-rule="evenodd"><path pid="0" d="M15.6.75c4.2 0 7.775 1.425 10.725 4.275 2.95 2.85 4.425 7.225 4.425 13.125 0 4.7-1.025 9.075-3.075 13.125-2.05 4.05-5.15 7.325-9.3 9.825-4.15 2.5-9.125 3.75-14.925 3.75h-.9V36.9H3c2.8 0 5.35-.575 7.65-1.725 2.3-1.15 3.9-2.825 4.8-5.025h-.15c-4.4 0-8.05-1.325-10.95-3.975C1.45 23.525 0 20.1 0 15.9 0 11.6 1.525 8 4.575 5.1 7.625 2.2 11.3.75 15.6.75zm36.75 0c4.2 0 7.775 1.425 10.725 4.275 2.95 2.85 4.425 7.225 4.425 13.125 0 4.7-1.025 9.075-3.075 13.125-2.05 4.05-5.15 7.325-9.3 9.825-4.15 2.5-9.125 3.75-14.925 3.75h-.9V36.9h.45c2.8 0 5.35-.575 7.65-1.725 2.3-1.15 3.9-2.825 4.8-5.025h-.15c-4.4 0-8.05-1.325-10.95-3.975-2.9-2.65-4.35-6.075-4.35-10.275 0-4.3 1.525-7.9 4.575-10.8C44.375 2.2 48.05.75 52.35.75z"/></g>'
  }
})
